import Swal from "sweetalert2";
  function TableRaw (props){
   let onDeleteHandler =() => {
    confirmDelete();
    //  props.deleteHandler(props.id)
   } ;
   let confirmDelete =() =>{
    Swal.fire({
    
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        props.deleteHandler(props.id)
        // Swal.fire({
        //   icon: 'success',
        //   text: "Greate!",
        //   title: 'Expenses delete succesflly!',
         
        // })
        // .then((result) => {
        //   /* Read more about handling dismissals below */
        //   if (result.dismiss === Swal.DismissReason.timer) {
        //     console.log('I was closed by the timer')
        //   }
        // })
      }
    })
   }
  return ( 
    <tr>
    <td> {props.title} </td>
    <td> {props.date}</td>
    <td>{props.price} </td>
    <td colSpan="2">{props.description} </td>
    <td className="text-right">
      <a href="#" className="delete" onClick={onDeleteHandler}>
       <i className="fa fa-trash-o" aria-hidden="true"/>
      </a>
    </td>
  </tr>
  
  )
}
export default TableRaw;